export default {
  getActivityDetail: '/activityCenter/inviteCourierActivity/getActivityDetail'
}
